import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export type AzWarningBannerVariant = 'warning' | 'info' | 'success';

@Component({
  selector: 'app-az-warning-banner',
  imports: [],
  templateUrl: './az-warning-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './az-warning-banner.component.scss',
})
export class AzWarningBannerComponent {
  @Input() testId = '';
  @Input() variant: AzWarningBannerVariant = 'warning';

  get icon(): string {
    if (this.variant === 'success') return 'check_circle';
    return this.variant === 'info' ? 'info' : 'warning';
  }
}
